var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailMarkDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 41,
    viewBox: "0 0 53 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62305 1.16504H45.5332C48.4942 1.16522 50.9053 3.57704 50.9053 6.53809V21.2812C50.9051 21.976 50.3432 22.5381 49.6484 22.5381C48.9538 22.5379 48.3928 21.9759 48.3926 21.2812V6.53809C48.3926 6.15805 48.3099 5.80792 48.1777 5.47754L48.0479 5.15039L47.7822 5.38086L26.2588 24.0625C26.0235 24.267 25.7393 24.3681 25.4434 24.3682C25.1584 24.3682 24.8616 24.2665 24.627 24.0625L3.2998 5.54004L3.00391 5.2832L2.89551 5.66016C2.81994 5.92466 2.75098 6.2214 2.75098 6.53809V34.1494C2.7512 36.0029 4.26056 37.498 6.10059 37.498H34.9121C35.607 37.498 36.1689 38.06 36.1689 38.7549C36.1689 39.4498 35.607 40.0117 34.9121 40.0117H6.10059C2.87026 40.0117 0.25 37.3799 0.25 34.1611V6.53809C0.25 5.05779 0.856346 3.72048 1.83008 2.74805L2.0293 2.55859C2.06497 2.5319 2.09248 2.50696 2.1123 2.4873C3.04896 1.66775 4.27778 1.16504 5.62305 1.16504ZM5.45898 4.10547L25.291 21.3164L25.4551 21.458L25.6191 21.3164L45.4395 4.10547L45.9443 3.66602H4.95312L5.45898 4.10547Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 33.5,
    r: 5.5,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailMarkDot);
export default __webpack_public_path__ + "static/media/email_mark_dot.d738b1574ce5024557de7ef287f4c290.svg";
export { ForwardRef as ReactComponent };